import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorNo1099 = (taxClassification: CompanyStructure) =>
  taxClassification === CompanyStructure.CorporationS ||
  taxClassification === CompanyStructure.CorporationC ||
  taxClassification === CompanyStructure.LLCCorporationS ||
  taxClassification === CompanyStructure.LLCCorporationC;
